

export const getFiltersAplicates = (state)=>{
    return state.filtersAplicates
}